<template>
    <div id="page-content-wrapper">
        <div class="table-header">
            <h4> Clienti </h4>
            <div class="search-box">
                <form class="search-form">
                    <input type="search" name="q" placeholder="dsadsa"
                           id="user-search">
                    <span class="focus-input"></span>
                    <span class="symbol-input">
                            <i class="fas fa-search"></i>
                        </span>
                </form>
                <button type="button" class="template-button" onclick="window.location.href='/employees/create'">
                    <i class="fas fa-plus-circle"></i> Adauga Client
                </button>
                <ul>
                    <li v-for="client in clients" :key="client.id">{{client.last_name}}</li>
                </ul>
                <button @click="deleteClient(49)">DELETE</button>
            </div>
        </div>
    </div>
</template>

<script>
import TestService from '../api-services/test.service'
export default {
  name: 'Tests',
  data () {
    return {
      clients: []
    }
  },
  methods: {
    getClients (params = '') {
      TestService.create().then((response) => {
        console.log(response.data)
        this.clients = response.data.data
      }).catch((error) => {
        console.log(error.response.data)
      })
    },
    deleteClient (id) {
      // console.log(client)
      TestService.delete(id).then((response) => {
        let client = this.clients.find(client => client.id === id)
        let index = this.clients.indexOf(client)
        if (index !== -1) this.clients.splice(index, 1)
        this.clients = response.data.data
      }).catch((error) => {
        console.log(error.response.data)
      })
    }
  },
  computed: {
  },
  created () {
    console.log('created')
    this.getClients()
  }
}
</script>
